module.exports = __webpack_public_path__ + "img/bmgz.ec29b00b.svg";